<form nz-form style="padding-top:12px;padding-right:12px" [formGroup]="validateForm" autocomplete="off">
  <div nz-row [nzGutter]="['0','0']">
    <div nz-col nzSm="24" nzMd="24">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="oldPassword" nzRequired>Mật khẩu cũ</nz-form-label>
        <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!" nzHasFeedback >
          <input nz-input formControlName="oldPassword" name="oldPassword" type="password" placeholder="Nhập nhập mật khẩu cũ">
      </nz-form-control>
      </nz-form-item >
    </div>
    <div nz-col nzSm="24" nzMd="24">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="password" nzRequired>Mật khẩu mới</nz-form-label>
        <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!" nzHasFeedback >
          <input nz-input formControlName="password" name="password" type="password" placeholder="Nhập mật khẩu mới">
      </nz-form-control>
      </nz-form-item >
    </div>
    <div nz-col nzSm="24" nzMd="24">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="confirmPassword" nzRequired>Nhập lại mật khẩu</nz-form-label>
        <nz-form-control nzSpan="24" [nzErrorTip]="errorTpl" nzHasFeedback >
          <input nz-input formControlName="confirmPassword" name="confirmPassword" type="password" placeholder="Nhập lại mật khẩu">
          <ng-template #errorTpl let-control>
            <ng-container *ngIf="control.hasError('required')">
              Vui lòng nhập trường bắt buộc!
            </ng-container>
            <ng-container *ngIf="control.hasError('mustMatch')">
              Không khớp mật khẩu mới!
            </ng-container>
          </ng-template>
      </nz-form-control>
      </nz-form-item >
    </div>
  </div>
  <div class="drawer-footer">
    <popup-btn-footer 
      [isDisableUpdate]="false"
      [isUpdateAndClose]="true" 
      (updateAndClose)="UpdateChange()"
      (close)="close()"
      >
    </popup-btn-footer>
  </div>
</form>
